/**
 * Performance-optimized layout settings for all graph sizes.
 * Optimizations (Barnes-Hut, line edges, skip FA2) apply universally —
 * the previous 50K threshold caused crashes on graphs well below that size.
 */

export const HUGE_GRAPH_THRESHOLD = 0;

export const NOVERLAP_SETTINGS = {
  maxIterations: 20,
  ratio: 1.1,
  margin: 10,
  expansion: 1.05,
} as const;

const HUGE_NOVERLAP_SETTINGS = {
  maxIterations: 3,
  ratio: 1.2,
  margin: 15,
  expansion: 1.0,
} as const;

export function getFA2Settings(_nodeCount: number): Record<string, unknown> {
  return {
    gravity: 0.05,
    scalingRatio: 150,
    slowDown: 10,
    barnesHutOptimize: true,
    barnesHutTheta: 1.5,
    strongGravityMode: false,
    outboundAttractionDistribution: false,
    linLogMode: false,
    adjustSizes: false,
    edgeWeightInfluence: 0,
  };
}

// Pre-seeded positions are sufficient; skip FA2 to prevent crashes at scale.
export function getLayoutDuration(_nodeCount: number): number {
  return 0;
}

export function getNovellapSettings(
  _nodeCount: number,
): typeof NOVERLAP_SETTINGS | typeof HUGE_NOVERLAP_SETTINGS {
  return HUGE_NOVERLAP_SETTINGS;
}

// Line edges for all graphs — curved Bezier rendering is too costly at scale.
export function usesCurvedEdges(_nodeCount: number): boolean {
  return false;
}
